<app-contract-custom-subheader/>
<app-custom-actions-flow-contract/>
<div class="details-content container-fluid h-100">
  <div class="row h-100">
    <div class="col-content d-flex flex-column h-100">
      @if (this.contractBase$ | async; as contract) {
        <div
          class="page-container"
        >
          <div class="card card-light w-100">
            <app-smart-actions [smartActions]="this.smartActions"/>
            <div class="card-body">
              <div class="container-fluid">
                <div class="row mb-2">
                  <div class="col-12 col-md-9 mr-auto">
                    <div class="row">
                      <div class="col">
                        <label class="form-title-label" translate
                        >CONTRACT_LBL_NAME</label
                        >
                        <input
                          class="form-control-plaintext form-title"
                          type="text"
                          readonly
                          value="{{ contract.name }}"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-md">
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >CONTRACT_LBL_CLIENT</label
                      >
                      <div class="col">
                              <span class="form-control-plaintext form-control-sm">
                                <app-link-to
                                  [id]="contract.contactId.toString()"
                                  [label]="contract.contactName"
                                  [url]="'/Contacts/Contacts/Details/'"
                                />
                                </span>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >CONTRACT_LBL_ADDRESS</label
                      >
                      <div class="col">
                        <div
                          class="form-control-plaintext form-control-sm mb-2 h-100 p-0"
                        >
                          <app-address
                            [address]="contract.contactAddress"
                            [address2]="contract.contactAddress2"
                            [zipCode]="contract.contactZipCode"
                            [city]="contract.contactCity"
                            [country]="contract.contactCountryName"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >CONTRACT_LBL_SALESPERSON</label
                      >
                      <div class="col">
                        <input
                          class="form-control-plaintext form-control-sm"
                          type="text"
                          readonly
                          value="{{ contract.salesPersonContactName }}"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >CONTRACT_LBL_SALESTEAM</label
                      >
                      <div class="col">
                        <input
                          class="form-control-plaintext form-control-sm"
                          type="text"
                          readonly
                          value="{{ contract.salesTeamName }}"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >CONTRACT_LBL_MANAGER</label
                      >
                      <div class="col">
                        <input
                          class="form-control-plaintext form-control-sm"
                          type="text"
                          readonly
                          value="{{ contract.contractManagerContactName }}"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >CONTRACT_LBL_INTERNAL_ID</label
                      >
                      <div class="col">
                        <input
                          class="form-control-plaintext form-control-sm"
                          type="text"
                          readonly
                          value="{{ contract.internalId }}"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >CONTRACT_LBL_CATEGORY</label
                      >
                      <div class="col">
                        <div
                          class="form-control-plaintext form-control-sm badge-list"
                        >
                          <app-badge
                            [message]="contract.productCategoryName"
                            [color]="contract.categoryColor"
                          ></app-badge>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >CONTRACT_LBL_COMPANY</label
                      >
                      <div class="col">
                        <app-link-to
                          class="form-control-plaintext form-control-sm"
                          [id]="
                          contract.productProductLineInsuranceCompanyId?.toString()
                        "
                          [label]="
                          contract.productProductLineInsuranceCompanyContactName
                        "
                          [url]="'/Insurance/InsuranceCompanies/Details/'"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >CONTRACT_LBL_PRODUCTLINE</label
                      >
                      <div class="col">
                        <app-link-to
                          class="form-control-plaintext form-control-sm"
                          [id]="contract.productProductLineId?.toString()"
                          [label]="contract.productProductLineName"
                          [url]="'/Insurance/ProductLines/Details/'"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >CONTRACT_LBL_PRODUCT</label
                      >
                      <div class="col">
                        <app-link-to
                          class="form-control-plaintext form-control-sm"
                          [id]="contract.productId?.toString()"
                          [label]="contract.productName"
                          [url]="'/Insurance/Products/Details/'"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >CONTRACT_LBL_EFFECT_DATE</label
                      >
                      <div class="col">
                        <span
                          class="form-control-plaintext form-control-sm">
                          {{ contract.startDate | date : "dd/MM/yyyy" }}
                        </span>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >CONTRACT_LBL_SUBSCRIPTION_DATE</label
                      >
                      <div class="col">
                        <input
                          class="form-control-plaintext form-control-sm"
                          type="text"
                          readonly
                          [value]="
                          contract.subscriptionDate
                            ? (contract.subscriptionDate | date : 'dd/MM/yyyy')
                            : '-'
                        "
                        />
                      </div>
                    </div>
                    @if (contract.terminationDate) {
                      <div class="form-group row">
                        <label class="col-4 col-form-label-sm" translate
                        >CONTRACT_LBL_TERMINATION_DATE</label
                        >
                        <div class="col">
                          <input
                            class="form-control-plaintext form-control-sm"
                            type="text"
                            readonly
                            [value]="
                          contract.terminationDate
                            ? (contract.terminationDate | date : 'dd/MM/yyyy')
                            : '-'
                        "
                          />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-4 col-form-label-sm" translate
                        >CONTRACT_LBL_TERMINATION_REASON</label
                        >
                        <div class="col">
                          <input
                            class="form-control-plaintext form-control-sm"
                            type="text"
                            readonly
                            [value]="
                          contract.terminationReasonName
                            ? contract.terminationReasonName
                            : '-'
                        "
                          />
                        </div>
                      </div>
                    }
                  </div>
                </div>
                <app-contract-tabs-details
                  [category]="contract.productCategoryProductCategoryEnumKey"
                  [contractBase]="contract"
                />
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    @if (this.contractBase$ | async; as contract) {
      <div class="col-comment">
        <app-comment-panel
          [entityType]="'Contract'"
          [entityId]="contract.id.toString()"
        ></app-comment-panel>
      </div>
    }
  </div>
</div>
